import React, { useEffect, useState, useContext, useMemo } from "react";
import { getCostIframeUrlApi } from "@/services"
import { useParams } from "react-router-dom"
import { Table, ConfigProvider, Button, Input, Spin } from "antd"
import { CostContext } from './cost'

const Index = () => {
    const params = useParams()
    const projectID = params.projectID || ""

    const contextValue = useContext(CostContext)

    const departData = useMemo(() => {
        return {
            departsLoading: contextValue ? contextValue.departsLoading : false,
            departs: contextValue ? contextValue.departs : [],
        }
    }, [contextValue])

    const [url, setUrl] = useState("")
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!contextValue) return
        setLoading(true)
        const vals = contextValue.departs.map(v => `${v.companyCode},${v.departmentCode},${v.majorCode}`)

        getCostIframeUrlApi(2, projectID, vals).then(res => {
            if (res.url) {
                setUrl(res.url)
            }
        })
    }, [contextValue])
    const onIframeLoad = () => {
        setLoading(false)
    }
    return (
        <Spin spinning={loading || departData.departsLoading}>
            <div>
                <iframe src={url} width="100%" className="border-none h-[80vh] min-h-[600px]" onLoad={onIframeLoad}></iframe>
            </div>
        </Spin>
    )
}
export default Index